export enum StageStatusEnum {
  DONE = 'Done',
  IN_PROGRESS = 'In progress',
  TO_DO = 'To do',
}

export interface ITimelineItem {
  startDate: string;
  endDate: string;
  stage: string;
  status?: StageStatusEnum;
}

export type TimelineType = 'month' | 'quarter' | 'halfYear';
